import React from "react";
import { SimpleShowLayout, TextField, NumberInput } from "react-admin";
import { getPerGameStatValue, perGameCalc } from "util/stats";
import { useFormState, useForm } from "react-final-form";
import _ from "lodash";

const FormTab = (props) => {
  const { values } = useFormState();
  const form = useForm();

  const updateStat = (event, updateField) => {
    const gameCount = _.get(values, "basketball.playerGameCount");
    const perGameStat = getPerGameStatValue(event, gameCount);
    form.change(`basketball.${updateField}`, perGameStat);
  };

  const updateAllRelatedStats = (event) => {
    if (!event || !event.target) return;
    const { value } = event.target;
    const stats = _.get(values, "basketball");
    const { totalPoints, rebounds } = stats;
    const pointsPerGame = perGameCalc(totalPoints, value);
    const reboundsPerGame = perGameCalc(rebounds, value);

    form.change("basketball.pointsPerGame", pointsPerGame);
    form.change("basketball.reboundsPerGame", reboundsPerGame);
  };

  return (
    <SimpleShowLayout {...props}>
      <TextField source="basketball.id" />
      <NumberInput
        source="basketball.playerGameCount"
        onChange={updateAllRelatedStats}
      />
      <NumberInput
        source="basketball.totalPoints"
        onChange={(e) => updateStat(e, "pointsPerGame")}
      />
      <NumberInput
        source="basketball.rebounds"
        onChange={(e) => updateStat(e, "reboundsPerGame")}
      />
      <NumberInput
        source="basketball.assists"
        onChange={(e) => updateStat(e, "assistsPerGame")}
      />
      <NumberInput
        source="basketball.threePointFieldGoals"
        onChange={(e) => updateStat(e, "threePointFieldGoalsPerGame")}
      />
      <NumberInput source="basketball.pointsPerGame" />
      <NumberInput source="basketball.reboundsPerGame" />
      <NumberInput source="basketball.assistsPerGame" />
      <NumberInput source="basketball.threePointFieldGoalsPerGame" />
    </SimpleShowLayout>
  );
};

export default FormTab;
